import classNames from 'classnames';
import styled, { keyframes } from 'styled-components';

const growAnimation = keyframes`
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    20% {
        opacity: 1;
        transform: scale(1.15)
    }
    80% {
        opacity: 1;
        transform: scale(1.15)
    }
    100% {
      opacity: 0;
      transform: scale(0.8);
    }
`;
const BlurWrapper = styled.div`
  filter: blur(40px);
`;
const Ellipse = styled.div`
  width: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  clip-path: ellipse(closest-side farthest-side);
  background: #e5aff9;

  &.holo {
    background: linear-gradient(
      160deg,
      #ff0000 20%,
      #ff8000,
      #ffff00,
      #00ff00,
      #0000ff,
      #8000ff 80%
    );
    animation: ${growAnimation} 2s linear forwards;
  }
`;

type Props = { show: boolean; holo?: boolean };
export const Glow = ({ show, holo }: Props) => {
  if (!show) return null;

  return (
    <BlurWrapper>
      <Ellipse className={classNames({ holo })} />
    </BlurWrapper>
  );
};
